module.exports = __webpack_public_path__ + "static/media/wgso.6504ef1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/QuotePage/TravelDetailsPanel/wgso.png
// module id = 1243
// module chunks = 0